<template>
  <div class="headline-row"
       v-if="(headlines && headlines.length > 0) || isLoading"
       @mouseenter="toggleMoreTooltip(true)"
       @mouseleave="toggleMoreTooltip(false)"
  >
    <div v-if="isLoading" class="loading-container">
      <DxLoadIndicator :visible="true"/>
    </div>
    <div v-else-if="headlines && headlines.length > 0" class="headline-snippet"
         v-html="headlines[0]"
    ></div>
    <div v-if="headlineCount > 1 && !isLoading">
      ...<span :id="headlineId" class="more-headlines"><b>{{headlineCount - 1}} more</b></span>
    </div>

    <DxTooltip v-if="headlineCount > 1 && !isLoading"
               :target="'#' + headlineId"
               v-model:visible="moreVisible"
               position="right"
    >
      <div class="all-headlines" v-html="combinedHeadlines"/>
    </DxTooltip>
  </div>
</template>

<script setup>
  import { ref, computed, watch, onMounted } from 'vue'
  import { DxTooltip } from "devextreme-vue/tooltip";
  import { DxLoadIndicator } from "devextreme-vue/load-indicator";

  const props = defineProps(['doc_id', 'textSearchStrings', 'headlines', 'onFetchHeadlines'])

  const moreVisible = ref(false)

  const headlines = ref([])
  const isLoading = ref(false)
  const loadHeadlines = async () => {
    if (!props.textSearchStrings || props.textSearchStrings.length === 0) {
      headlines.value = []
      return
    }
    isLoading.value = true
    const fetchedHeadlines = await props.onFetchHeadlines(props.doc_id, props.textSearchStrings)
    headlines.value = fetchedHeadlines || []
    isLoading.value = false
  }

  const combinedHeadlines = computed(() => headlines.value.join("<br/>"))
  const headlineCount = computed(() => headlines.value ? headlines.value.length : null)
  const headlineId = computed(() => `more-headlines-${props.doc_id}`)

  const toggleMoreTooltip = (isVisible) => {
    moreVisible.value = isVisible
  }

  // load headlines only when the component first comes online
  // if you load headlines anytime the text strings change then all existing HeadlinesPreviews will request new data
  // even though if they're in the SearchGrid they're about to be swept away by the new search result
  onMounted(() => {
    loadHeadlines()
  })
</script>

<style scoped lang="scss">
  .headline-row {
    display: flex;
    margin-bottom: 5px;
  }
  .headline-snippet {
    overflow: hidden;
    max-width: 600px;
  }
  .loading-container {
    display: flex;
    align-items: center;
  }
  .more-headlines {
    background-color: yellow;
  }
  .all-headlines {
    font-size: 12px;
    text-align: left;
    white-space: normal;
    max-width:500px;
    word-wrap: break-word;
  }
  :deep() .dx-tooltip-wrapper {
    width: 100%;
  }
</style>
